import { useEffect, useState } from "react";
import { Title, useDataProvider, useNotify, useStore } from "react-admin";
import { Box, Paper, Typography } from "@mui/material";
import CustomFilter from "features/CustomFilter";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";
import { useNotifyError } from "utils/useNotifyError";
import DisciplinePricesPage from "./Page";

export const DISCIPLINE_PRICES_STORE_KEY = "curriculumDisciplinePrices.filters";

const DisciplinePricesList = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const notifyError = useNotifyError();

  const [filters, setFilters] = useStore(DISCIPLINE_PRICES_STORE_KEY, null);
  const [academicYearId, setAcademicYearId] = useState(filters?.academicYearId ?? null);
  const [specialityId, setSpecialityId] = useState(filters?.specialityId ?? null);

  const [academicYearChoices, setAcademicYearChoices] = useState([]);
  const [specialityChoices, setSpecialityChoices] = useState([]);

  useEffect(() => {
    dataProvider
      .customRequest(studentRequests.getAcademicYearsSelect())
      .then(res => setAcademicYearChoices(res.data ?? []))
      .catch(error => notifyError(error));
  }, [dataProvider, notifyError]);

  useEffect(() => {
    dataProvider
      .customRequest(administrationRequests.getSpecialitiesSelect())
      .then(res => setSpecialityChoices(res.data ?? []))
      .catch(error => notifyError(error));
  }, [dataProvider, notifyError]);

  const onSearch = () => {
    if (!academicYearId) {
      notify("Моля изберете учебна година!", { type: "error" });
      return;
    }
    if (!specialityId) {
      notify("Моля изберете специалност!", { type: "error" });
      return;
    }
    setFilters({ academicYearId, specialityId });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Title title="Цени на дисциплини" />
      <CustomFilter
        filters={[
          {
            label: "Учебна година",
            value: academicYearId,
            setValue: setAcademicYearId,
            type: "autocomplete",
            choices: academicYearChoices,
            multiple: false,
          },
          {
            label: "Специалност",
            value: specialityId,
            setValue: setSpecialityId,
            type: "autocomplete",
            choices: specialityChoices,
            multiple: false,
          },
        ]}
        buttonLabel="Провери"
        buttonOnClick={onSearch}
      />
      {!filters ? (
        <Paper>
          <Box mt={3}>
            <Typography
              variant="inherit"
              align="center"
              color="secondary"
            >
              Изберете учебна година и специалност, за да заредите цените на дисциплините.
            </Typography>
          </Box>
        </Paper>
      ) : (
        <DisciplinePricesPage
          academicYearId={filters.academicYearId}
          specialityId={filters.specialityId}
        />
      )}
    </Box>
  );
};

export default DisciplinePricesList;
